<template>
  <div class="home">
    <div
      class="game_top_content"
      :style="{ overflowY: isNoScroll ? 'hidden' : 'auto' }"
      v-touchmove
    >
      <div
        class="gameback"
        :class="[
          { 'no-banner skeleton-shimmer': !activityBanner || !activityBannerLoaded },
          isMobile ? 'mobile' : 'pc',
        ]"
      >
        <img
          v-if="activityBanner"
          :src="activityBanner"
          @load="activityBannerLoaded = true"
          @error="activityBannerLoaded = true"
          :alt="bannerAlt"
        />
      </div>
      <div class="game_top_main_content">
        <!-- 游戏列表：布局与适配参考 Goods 列表；骨架同 Goods/LoadingItem -->
        <section class="section games">
          <div class="games-list" :class="[isMobile ? 'mobile' : 'pc']">
            <template v-if="loading && gameList.length === 0">
              <div v-for="n in skeletonCount" :key="'home-sk-' + n" class="games-skeleton-cell">
                <LoadingItem />
              </div>
            </template>
            <template v-else>
              <div
                class="game-card"
                v-for="(game, index) in gameList"
                :key="index"
                @click="goToGame(game)"
              >
                <!-- 模糊背景 -->
                <div class="goods-icon">
                  <div
                    class="game-card-bg"
                    :style="{
                      backgroundImage: game.background ? `url(${game.background})` : 'none',
                    }"
                  ></div>
                </div>
                <!-- 白色带弧度子区域：图标、名字、按钮 -->
                <div class="game-card-white">
                  <div class="game-icon" :style="{ backgroundImage: `url(${game.logo})` }"></div>
                  <div class="game-title">
                    <div class="game-title__text">{{ $t(`store.game_name_${game.game_id}`) }}</div>
                  </div>
                  <div class="game-button" @click.stop="goToGame(game)">
                    {{ $t('btn.goTopup') }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </section>
      </div>
      <Foot />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Foot from '@/components/common/foot.vue'
import LoadingItem from '@/components/common/Goods/LoadingItem.vue'
import './home.css'
import { getBJHomePage, getFZHomePage } from '@/api/index.js'

export default {
  name: 'Home',
  components: {
    Foot,
    LoadingItem,
  },
  data() {
    return {
      gameList: [],
      loading: true,
      skeletonCount: 6,
      activityBanner: '',
      activityBannerLoaded: false,
    }
  },
  computed: {
    ...mapState({
      isNoScroll: (state) => state.app.isNoScroll,
      accept: (state) => state.app.accept,
      isMobile: (state) => state.app.isMobile,
    }),
    bannerAlt() {
      var keys = [
        'image_alt.banner_1_webshop-homepage',
        'image_alt.banner_2_webshop-homepage',
        'image_alt.banner_3_webshop-homepage',
        'image_alt.banner_4_webshop-homepage',
        'image_alt.banner_5_webshop-homepage',
        'image_alt.banner_6_webshop-homepage',
      ]
      try {
        return keys
          .map((key) => (this.$te(key) && this.$t(key)) || '')
          .filter((msg) => !!msg)
          .join(', ')
      } catch (error) {
        return ''
      }
    },
  },
  created() {
    this.getGameList()
    this.$rum.report(
      'page_show',
      {
        url: window.location.href,
      },
      3
    )
  },
  methods: {
    async getGameList() {
      this.$rum.report('getGameList', {}, 3)
      this.loading = true
      try {
        const res = await getFZHomePage({ os: this.isMobile ? 'mobile' : 'pc' })
        if (res.data.code === 1) {
          this.gameList = res?.data?.data?.homepage_game_config || []
          this.activityBanner = res?.data?.data.banner_icon
        } else if (+res.data.code >= 500 && +res.data.code < 600) {
          this.getBackGameList()
        }
      } catch (error) {
        console.error('获取游戏列表失败:', error)
        this.getBackGameList()
      } finally {
        this.loading = false
      }
    },

    async getBackGameList() {
      this.$rum.report('getBackGameList', {}, 3)
      this.loading = true
      try {
        const res = await getBJHomePage({ os: this.isMobile ? 'mobile' : 'pc' })
        if (res.data.code === 1) {
          this.gameList = res?.data?.data?.homepage_game_config || []
          this.activityBanner = res?.data?.data.banner_icon
        }
      } catch (error) {
        console.error('获取游戏列表失败:', error)
      } finally {
        this.loading = false
      }
    },

    goToGame(game) {
      if (game.url) window.location.href = game.url
    },
    handleImageError(event) {
      // 图片加载失败时使用默认图片
      event.target.src = require('@/assets/image/logo.png')
    },
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep(.foot) {
  margin-top: 10px;
}

.section.games {
  padding: 20px 0px 0 0px;

  .empty-title {
    height: 20px;
  }
  .games-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 11px;
    margin: 0 auto 10px;
    position: relative;
    box-sizing: border-box;
    padding: 0 2px;
  }

  .games-skeleton-cell {
    width: 100%;
    min-width: 0;
    pointer-events: none;
    cursor: default;
    -webkit-tap-highlight-color: transparent;
  }
}

.game-card {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  width: 100%;
  border-radius: 12px;
  cursor: pointer;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;

  .game-card-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 88px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-position: 50%;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    filter: blur(3px);
    transform: scale(1.1);
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);
    }
  }

  // 白色带弧度子 div（高 183，图标 114 一半压线）
  .game-card-white {
    position: relative;
    background: #ffffff;
    border-radius: 10px 10px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 25.5%;
    padding-bottom: 5.5%;
    box-sizing: border-box;
  }

  .game-icon {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, -50%);
    width: 45.2%;
    aspect-ratio: 1 / 1;
    border-radius: 12px;
    border: 2px solid #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    flex-shrink: 0;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .game-title {
    flex: 1;
    min-height: 0;
    min-height: 34px;
    margin-bottom: 4px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
  }

  /* 窄屏三列时随卡片变窄；≥701px 在媒体查询中恢复 max-width:220px */
  .game-title__text {
    font-family: 'roboto-bold';
    font-size: 14px;
    font-weight: 700;
    color: #1a1a1a;
    text-align: center;
    max-width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    line-height: 15.5px;
  }

  .game-button {
    height: 32px;
    width: calc(100% - 14px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 16px;
    background: rgba(255, 170, 0, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    text-align: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    &:hover,
    &:active {
      background: rgba(235, 157, 2, 1);
    }
  }
}

.goods-icon {
  width: 100%;
  padding-top: 40.5%;
  position: relative;
}

@media (min-width: 554px) {
  .section.games .games-list {
    grid-template-columns: repeat(3, 1fr);
  }
}

.pc {
  .game-card-white {
    padding-top: 25.5%;
    padding-bottom: 5.5%;
  }

  .game-title {
    min-height: 53px;
    padding: 0 20px;
  }

  .game-title .game-title__text {
    font-size: 21px;
    line-height: 23px;
  }

  .game-button {
    width: calc(100% - 20.5px);
    height: 48px;
    border-radius: 48px;
    font-size: 24px;
  }
}
</style>
